export function addAll(set, iterable) {
    for (const value of iterable) {
        set.add(value);
    }
    return set;
}
export function mapSet(set, fn) {
    const result = new Array(set.size);
    let i = 0;
    for (const value of set) {
        result[i++] = fn(value);
    }
    return result;
}
